const imageOverlayConfig = {
    QPT: [
    {
      page: 12,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            eng: '/harmful.png'
          },
          style: {
            top: {
              // eng: '705px',
              eng: '185px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              eng: '/core_bacteria.png'
            },
            style: {
              top: {
                // eng: '790px',
                eng: '390px'
              },
            left: '64px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            eng: '/probiotics.png'
          },
          style: {
            top: {
              // eng: '880px',
              eng: '622px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 11,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              // eng: '705px',
              thai: '185px'
            },
            left: '61px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '390px'
              },
            left: '64px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '622px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 16,
      images: [
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '507px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 17,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '705px',
              thai: '500px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '790px',
                thai: '595px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '600px',
              thai: '727px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 18,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '510px',
              thai: '500px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '600px',
                thai: '637px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '732px',
              thai: '728px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 19,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmful.png',
            // thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '545px',
              // thai: '500px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '676px',
                thai: '662px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '765px',
              thai: '794px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 20,
      images: [
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '680px',
                // thai: '662px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '812px',
              // thai: '794px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 22,
      images: [
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '612px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '740px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 23,
      images: [
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '770px',
                thai: '658px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '900px',
              thai: '741px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 24,
      images: [
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '800px',
                // thai: '658px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '892px',
              // thai: '741px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 25,
      images: [
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '120px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '286px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 26,
      images: [
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '125px',
                // thai: '120px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '300px',
              // thai: '286px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 27,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              // eng: '705px',
              thai: '120px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '245px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '408px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 28,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmful.png',
            // thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '125px',
              // thai: '120px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '257px',
                // thai: '245px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '426px',
              // thai: '408px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 30,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              // eng: '705px',
              thai: '116px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '212px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '302px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 31,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmful.png',
            // thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '124px',
              // thai: '116px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '220px',
                // thai: '212px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '311px',
              // thai: '302px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 32,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              // eng: '705px',
              thai: '116px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '360px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '483px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 33,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmful.png',
            // thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '127px',
              // thai: '116px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '378px',
                // thai: '360px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '515px',
              // thai: '483px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 34,
      images: [
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '116px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '280px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 35,
      images: [
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '127px',
                // thai: '116px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '302px',
              // thai: '280px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 36,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmful.png',
            thai: '/harmful_thai.png'
          },
          style: {
            top: {
              // eng: '725px',
              thai: '712px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                // eng: '790px',
                thai: '797px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              // eng: '880px',
              thai: '878px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 37,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmful.png',
            // thai: '/harmful_thai.png'
          },
          style: {
            top: {
              eng: '725px',
              // thai: '690px'
            },
            left: '64px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '805px',
                thai: '695px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '888px',
              thai: '782px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
    {
      page: 38,
      images: [
        {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
              top: {
                eng: '702px',
                // thai: '777px'
              },
            left: '65px',
            width: '165px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_thai.png'
          },
          style: {
            top: {
              eng: '790px',
              // thai: '863px'
            },
            left: '64px',
            width: '140px'
          }
        },
      ]
    },
  ],
  
  '9P': [
    {
      page: 12,
      images: [
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics.png',
            // thai: '/probiotics_3_thai.png'
          },
          style: {
            top: '237px',
            left: '50px',
            width: {
              eng: '165px',
              // thai: '145px'
            }
          }
        },
          {
            key: 'core',
            src: {
              eng: '/core_bacteria.png',
              // thai: '/core_bacteria_thai.png'
            },
            style: {
            top: '150px',
            left: '50px',
              width: {
                eng: '190px',
                // thai: '145px'
              }
          }
        },
      ]
    },
    {
      page: 11,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/probioticsv3.png',
            thai: '/core_bacteria_thai.png'
          },
          style: {
            top: '150px',
            left: '53px',
            width: {
              // eng: '190px',
              thai: '190px'
            }
          }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probioticsv3.png',
            thai: '/probiotics_thai.png'
          },
          style: {
            top: '240px',
            left: '53px',
            width: {
              // eng: '190px',
              thai: '165px'
            }
          }
        },
      ]
    },
  ],
  'Allergy and Skin': [
    // refference sizing img
    {
      page: 12,
      images: [
        {
          key: 'harmful',
          src: {
            eng: '/harmful_2.png',
            // thai: '/harmful_2_thai.png'
          },
          style: {
            top: {
              eng: '180px',
              // thai: '695px'
            },
            left: '50px',
            width: {
              eng: '190px',
              // thai: '145px'
            }
          }
        },
        {
          key: 'core',
          src: {
            eng: '/core_bacteria_1.png',
            // thai: '/core_bacteria_1_thai.png'
          },
          style: {
            top: {
              eng: '333px',
              // thai: '695px'
            },
            left: '50px',
            width: {
              eng: '190px',
              // thai: '145px'
            }
          }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probiotics_3.png',
            // thai: '/probiotics_3_thai.png'
          },
          style: {
            top: '500px',
            left: '50px',
            width: {
              eng: '190px',
              // thai: '145px'
            }
          }
        },
      ]
  },
  {
    page: 11,
    images: [
      {
        key: 'harmful',
        src: {
          // eng: '/harmful_2.png',
          thai: '/harmful_2_thai.png'
        },
        style: {
          top: {
            // eng: '180px',
            thai: '175px'
          },
          left: '50px',
          width: {
            // eng: '190px',
            thai: '190px'
          }
        }
      },
      {
        key: 'core',
        src: {
          // eng: '/core_bacteria_1.png',
          thai: '/core_bacteria_1_thai.png'
        },
        style: {
          top: {
            // eng: '370px',
            thai: '333px'
          },
          left: '50px',
          width: {
            // eng: '190px',
            thai: '190px'
          }
        }
      },
      {
        key: 'probiotics',
        src: {
          // eng: '/probiotics_3.png',
          thai: '/probiotics_3_thai.png'
        },
        style: {
          top: {
            // eng: '370px',
            thai: '500px'
          },
          left: '50px',
          width: {
            // eng: '190px',
            thai: '190px'
          }
        }
      },
    ]
  },
],
'Allergy and Skin_kids': [
  // refference sizing img
  {
    page: 12,
    images: [
      {
        key: 'harmful',
        src: {
          eng: '/harmful_2.png',
          // thai: '/harmful_2_thai.png'
        },
        style: {
          top: {
            eng: '180px',
            // thai: '695px'
          },
          left: '50px',
          width: {
            eng: '190px',
            // thai: '145px'
          }
        }
      },
      {
        key: 'core',
        src: {
          eng: '/core_bacteria_1.png',
          // thai: '/core_bacteria_1_thai.png'
        },
        style: {
          top: {
            eng: '260px',
            // thai: '695px'
          },
          left: '50px',
          width: {
            eng: '190px',
            // thai: '145px'
          }
        }
      },
      {
        key: 'probiotics',
        src: {
          eng: '/probiotics_3.png',
          // thai: '/probiotics_3_thai.png'
        },
        style: {
          top: '418px',
          left: '50px',
          width: {
            eng: '190px',
            // thai: '145px'
          }
        }
      },
    ]
},
{
  page: 11,
  images: [
    {
      key: 'harmful',
      src: {
        // eng: '/harmful_2.png',
        thai: '/harmful_2_thai.png'
      },
      style: {
        top: {
          // eng: '180px',
          thai: '175px'
        },
        left: '50px',
        width: {
          // eng: '190px',
          thai: '190px'
        }
      }
    },
    {
      key: 'core',
      src: {
        // eng: '/core_bacteria_1.png',
        thai: '/core_bacteria_1_thai.png'
      },
      style: {
        top: {
          // eng: '370px',
          thai: '260px'
        },
        left: '50px',
        width: {
          // eng: '190px',
          thai: '190px'
        }
      }
    },
    {
      key: 'probiotics',
      src: {
        // eng: '/probiotics_3.png',
        thai: '/probiotics_3_thai.png'
      },
      style: {
        top: {
          // eng: '370px',
          thai: '422px'
        },
        left: '50px',
        width: {
          // eng: '190px',
          thai: '190px'
        }
      }
    },
  ]
},
],

'Toxin': [
  {
    page: 11,
    images: [
      {
        key: 'harmful',
        src: {
          // eng: '/harmful_2.png',
          thai: '/harmful_thaiv4.png'
        },
        style: {
          top: {
            // eng: '180px',
            thai: '180px'
          },
          left: '65px',
          width: {
            // eng: '190px',
            thai: '190px'
          }
        }
      },
      {
        key: 'probiotics',
        src: {
          // eng: '/probiotics_3.png',
          thai: '/probiotics_thaiv5.png'
        },
        style: {
          top: {
            // eng: '370px',
            thai: '418px'
          },
          left: '65px',
          width: {
            // eng: '190px',
            thai: '190px'
          }
        }
      },
    ]
  },
  {
    page: 12,
    images: [
      {
        key: 'harmful',
        src: {
          eng: '/harmful_2.png',
          // thai: '/harmful_2_thai.png'
        },
        style: {
          top: {
            eng: '180px',
            // thai: '175px'
          },
          left: '45px',
          width: {
            eng: '215px',
            // thai: '190px'
          }
        }
      },
      {
        key: 'probiotics',
        src: {
          eng: '/probioticsv42.png',
          // thai: '/probiotics_3_thai.png'
        },
        style: {
          top: {
            eng: '417px',
            // thai: '490px'
          },
          left: '66px',
          width: {
            eng: '175px',
            // thai: '190px'
          }
        }
      },
    ]
  },
],

'oms': [
  {
    page: 11,
    images: [
      {
        key: 'core',
        src: {
          // eng: '/harmfulv4.png',
          thai: '/harmful_thaiv4.png'
        },
        style: {
          top: {
            // eng: '142px',
            thai: '180px'
          },
          left: '61px',
          width: '180px'
        }
      },
      {
          key: 'core',
          src: {
            // eng: '/corev4.png',
            thai: '/corebateria_thaiv4.png'
          },
          style: {
            top: {
              // eng: '342px',
              thai: '332px'
            },
          left: '64px',
          width: '180px'
          }
      },
      {
        key: 'probiotics',
        src: {
          // eng: '/probioticsv4.png',
          thai: '/probiotics_thaiv4.png'
        },
        style: {
          top: {
            // eng: '460px',
            thai: '485px'
          },
          left: '64px',
          width: '180px'
        }
      },
    ]
  },
  {
    page: 12,
    images: [
      {
        key: 'core',
        src: {
          eng: '/harmfulv4.png',
          // thai: '/harmful_thaiv4.png'
        },
        style: {
          top: {
            eng: '180px',
            // thai: '142px'
          },
          left: '61px',
          width: '180px'
        }
      },
      {
          key: 'core',
          src: {
            eng: '/corev4.png',
            // thai: '/corebateria_thaiv4.png'
          },
          style: {
            top: {
              eng: '335px',
              // thai: '342px'
            },
          left: '64px',
          width: '180px'
          }
      },
      {
        key: 'probiotics',
        src: {
          eng: '/probioticsv4.png',
          // thai: '/probiotics_thaiv4.png'
        },
        style: {
          top: {
            eng: '484px',
            // thai: '460px'
          },
          left: '64px',
          width: '180px'
        }
      },
    ]
  },
  ],
  
  'bwcallergy': [
    {
      page: 4,
      images: [
        {
          key: 'core',
          src: {
            // eng: '/harmfulv2.png',
            thai: '/harmful_thaiv2.png'
          },
          style: {
            top: {
              // eng: '142px',
              thai: '142px'
            },
            left: '61px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              // eng: '/corebacteriav2.png',
              thai: '/corebateria_thaiv2.png'
            },
            style: {
              top: {
                // eng: '342px',
                thai: '342px'
              },
            left: '64px',
            width: '180px'
            }
        },
        {
          key: 'probiotics',
          src: {
            // eng: '/probioticsv2.png',
            thai: '/probiotics_thaiv2.png'
          },
          style: {
            top: {
              // eng: '460px',
              thai: '460px'
            },
            left: '64px',
            width: '180px'
          }
        },
      ]
    },
    {
      page: 5,
      images: [
        {
          key: 'core',
          src: {
            eng: '/harmfulv2.png',
            // thai: '/harmful_thaiv2.png'
          },
          style: {
            top: {
              eng: '142px',
              // thai: '142px'
            },
            left: '61px',
            width: '180px'
          }
        },
        {
            key: 'core',
            src: {
              eng: '/corebacteriav2.png',
              // thai: '/corebateria_thaiv2.png'
            },
            style: {
              top: {
                eng: '342px',
                // thai: '342px'
              },
            left: '64px',
            width: '180px'
            }
        },
        {
          key: 'probiotics',
          src: {
            eng: '/probioticsv2.png',
            // thai: '/probiotics_thaiv2.png'
          },
          style: {
            top: {
              eng: '460px',
              // thai: '460px'
            },
            left: '64px',
            width: '180px'
          }
        },
      ]
    },
  ],
    'bwccore': [
      {
        page: 4,
        images: [
          {
              key: 'core',
              src: {
                // eng: '/corebacteriav2.png',
                thai: '/corebateria_thaiv2.png'
              },
              style: {
                top: {
                  // eng: '135px',
                  thai: '138px'
                },
              left: '64px',
              width: '180px'
              }
          },
          {
            key: 'probiotics',
            src: {
              // eng: '/probioticsv2.png',
              thai: '/probiotics_thaiv2.png'
            },
            style: {
              top: {
                // eng: '540px',
                thai: '543px'
              },
              left: '64px',
              width: '180px'
            }
          },
        ]
      },
      {
        page: 5,
        images: [
          {
              key: 'core',
              src: {
                eng: '/corebacteriav2.png',
                // thai: '/corebateria_thaiv2.png'
              },
              style: {
                top: {
                  eng: '135px',
                  thai: '138px'
                },
              left: '64px',
              width: '180px'
              }
          },
          {
            key: 'probiotics',
            src: {
              eng: '/probioticsv2.png',
              // thai: '/probiotics_thaiv2.png'
            },
            style: {
              top: {
                eng: '540px',
                // thai: '543px'
              },
              left: '64px',
              width: '180px'
            }
          },
        ]
      },
  ],
    'bwcdiamond': [
      {
        page: 4,
        images: [
          {
            key: 'harmful',
            src: {
              // eng: '/harmful_2.png',
              thai: '/harmful_2_thai.png'
            },
            style: {
              top: {
                // eng: '148px',
                thai: '142px'
              },
              left: '38px',
              width: {
                // eng: '220px',
                thai: '210px'
              }
            }
          },
          {
            key: 'core',
            src: {
              // eng: '/core_bacteria_1.png',
              thai: '/core_bacteria_1_thai.png'
            },
            style: {
              top: {
                // eng: '385px',
                thai: '380px'
              },
              left: '38px',
              width: {
                // eng: '220px',
                thai: '210px'
              }
            }
          },
        ]
      },
      {
        page: 5,
        images: [
          {
            key: 'probiotics',
            src: {
              eng: '/harmful_2.png',
              thai: '/probiotics_3_thai.png'
            },
            style: {
              top: {
                eng: '148px',
                thai: '124px'
              },
              left: '38px',
              width: {
                eng: '220px',
                thai: '210px'
              }
            }
          },
          {
            key: 'core',
            src: {
              eng: '/core_bacteria_1.png',
              // thai: '/core_bacteria_1_thai.png'
            },
            style: {
              top: {
                eng: '385px',
                // thai: '380px'
              },
              left: '38px',
              width: {
                eng: '220px',
                // thai: '210px'
              }
            }
          },
        ]
      },
      {
        page: 6,
        images: [
          {
            key: 'probiotics',
            src: {
              eng: '/probioticsv4.png',
              // thai: '/probiotics_2_thai2.png'
            },
            style: {
              top: '123px',
              left: '58px',
              width: {
                eng: '200px',
                // thai: '210px'
              }
            }
          }
        ]
      },
  ],
};

export default imageOverlayConfig;
